

<template>
    {{ dateFormat(Date_) }}
</template>

<script setup>

import moment from "moment";

const props = defineProps({
    Date_: {
    type: String,
    required: true,
  }
});

const dateFormat = ((date_) => {
      if(date_ == null || date_ == ""){
        return "000"
      }
      return moment(date_).format("DD - MM - YYYY");
    })


</script>
